<template>
  <loading-dialog :loading="loadingPage">
    <base-page-layout :title="pageTitle">
      <stepper :steppers="steppers" :step="2" />

      <status-icon :status="campaign.status" />

      <v-container class="pa-0 mariaCampaign-details" fluid>
        <v-row>
          <v-col cols="3">
            <div class="mariaCampaign-details-text">
              <h2>Defina os detalhes destes produtos</h2>
              <p>
                Essa parte é essencial para que você possa criar mensagens personalizadas para cada um dos seus consumidores, usando o produto e o preço como
                variáveis. Se você pretende utilizar o canal SMS, recomendamos remover acentos e outros caracteres especiais, para reduzir os custos com esse
                disparo.
              </p>
            </div>
          </v-col>

          <v-col cols="9">
            <div class="mariaCampaign-details-configs">
              <product-details-actions
                :unit-error="$v.campaign.units && $v.campaign.units.$error"
                :units.sync="campaign.units"
                :units-configuration.sync="campaign.units_configuration"
                :start-date-error="errorInitialDate"
                :start-date.sync="campaign.initial_date"
                :end-date-error="$v.campaign.final_date && $v.campaign.final_date.$error"
                :end-date.sync="campaign.final_date"
                :disable-fields="managementOffers || isMariaCampaignActivated || isMariaCampaignFinished"
                :default-data-type="defaultDataType"
              />
            </div>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12">
            <mf-tabs-menu v-if="campaign" v-model="offerTypeCurrentTab" :tabs="offersTypeTabs" :tabs-errors="[]" class="mt-4" />
            <offer-sale-table
              v-if="campaign.offerType === 'general'"
              ref="productsAbsoluteDiscount"
              :all-products="campaign.offer_sales"
              :has-segments="campaign.segments && campaign.segments.length > 0"
              :has-offer-sales="managementOffers"
              :campaign="campaign"
              offer-type="offer_sales"
              :show-info-card="showInactiveProductsMessage"
              :info-card-content="inactiveProductsMessage"
            />

            <offer-sale-table
              v-if="campaign.offerType === 'percentage'"
              ref="productsPercentageDiscount"
              :all-products="campaign.percentage_offer_sales"
              :has-segments="campaign.segments && campaign.segments.length > 0"
              :campaign="campaign"
              has-offer-sales
              offer-type="percentage_offer_sales"
              :show-info-card="showInactiveProductsMessage"
              :info-card-content="inactiveProductsMessage"
            />

            <offer-sale-table
              v-if="campaign.offerType === 'takepay'"
              ref="productsTakeAndPayDiscount"
              :all-products="campaign.takepay_offer_sales"
              :has-segments="campaign.segments && campaign.segments.length > 0"
              :campaign="campaign"
              has-offer-sales
              offer-type="takepay_offer_sales"
              :show-info-card="showInactiveProductsMessage"
              :info-card-content="inactiveProductsMessage"
            />

            <offer-sale-table
              v-if="campaign.offerType === 'combo'"
              ref="productsCombo"
              :all-products="campaign.combo_offer_sales"
              :has-segments="campaign.segments && campaign.segments.length > 0"
              :campaign="campaign"
              has-offer-sales
              offer-type="combo_offer_sales"
              :show-info-card="showInactiveProductsMessage"
              :info-card-content="inactiveProductsMessage"
            />
          </v-col>
        </v-row>

        <mf-action-buttons
          v-if="campaign.status"
          :primary-button="primaryButton"
          :secondary-button="secondaryButton"
          :extra-button="extraButton"
          :cancel-button="cancelButton"
        />
      </v-container>
    </base-page-layout>
  </loading-dialog>
</template>

<script>
import { findIndex } from 'lodash'
import { required } from 'vuelidate/lib/validators'

import { isFuture } from '@/helpers/validators.js'
import { mariaCampaignActions } from '@/modules/maria/campanha-da-maria/mixins/maria-campaign-actions'
import { getAllSingleProductsOutsideAndInsideGroup } from '@/modules/campanhas/gestao-ofertas-v2/helpers/products.js'
import ProductDetailsActions from '@/modules/maria/campanha-da-maria/views/components/ProductDetailsActions.vue'

import OfferSaleTable from '../components/Step2ProductTables/OfferSaleTable.vue'
export default {
  name: 'ProductDetails',

  components: {
    ProductDetailsActions,
    OfferSaleTable,
  },

  mixins: [mariaCampaignActions],

  data: () => ({
    offerTypeCurrentTab: 0,
    defaultDataType: null,
    steppers: [
      {
        step: 1,
        complete: true,
        stepName: 'Escolher produtos',
        pathName: '',
      },
      {
        step: 2,
        complete: false,
        stepName: 'Detalhes dos produtos',
        pathName: '',
      },
      {
        step: 3,
        complete: false,
        stepName: 'Orçamento',
        pathName: '',
      },
      {
        step: 4,
        complete: false,
        stepName: 'Canais',
        pathName: '',
      },
      {
        step: 5,
        complete: false,
        stepName: 'Revisão',
        pathName: '',
      },
    ],
    selectedSegments: [],
    managementOffers: false,
    offerSalesKeyNames: {
      offer_sales: 'offer_sales',
      percentage_offer_sales: 'percentage_offer_sales',
      takepay_offer_sales: 'takepay_offer_sales',
      combo_offer_sales: 'combo_offer_sales',
      target_products: 'target_products',
    },
  }),

  computed: {
    countVariables() {
      const variants = ['email', 'whatsapp', 'push', 'sms']
      let countVariablesArray = [0, 0, 0]
      let text = ''
      variants.map((variant) => {
        if (variant === 'email' && this.mariaCampaign?.shotConfiguration?.[variant]) {
          const baseText = this.mariaCampaign?.shotConfiguration?.[variant]?.message?.simple_email_configuration
          const textElements = [baseText.text, baseText.click_to_call_button_text, baseText.footer, baseText.subject]
          text = text.concat(...textElements)
        } else if (variant === 'whatsapp' && this.mariaCampaign?.shotConfiguration) {
          text = this.mariaCampaign?.shotConfiguration?.[variant]?.message.text
        } else if (variant === 'push' && this.mariaCampaign.shotConfiguration) {
          const baseText = this.mariaCampaign?.shotConfiguration?.[variant]
          const textElements = [baseText.inner_message_text, baseText.inner_message_title, baseText.text, baseText.title]
          text = text.concat(...textElements)
        } else {
          text = this.mariaCampaign?.shotConfiguration?.[variant].text
        }
        text = text || '' // text value can be null
        const expressions =
          this.campaign.offerType === 'combo'
            ? [/primeiro melhor combo/g, /segundo melhor combo/g, /terceiro melhor combo/g]
            : [/primeiro melhor produto/g, /segundo melhor produto/g, /terceiro melhor produto/g]
        expressions.forEach((item, index) => {
          if (text.match(item || [])) {
            countVariablesArray[index] = 1
          }
        })
      })
      return countVariablesArray.reduce((total, count) => total + count, 0)
    },
    inactiveProductsMessage() {
      let channels = []
      if (this.mariaCampaign?.shotConfiguration?.whatsapp.appChannelOptions?.toggleAppActivated) {
        channels.push('Whatsapp')
      }
      if (this.mariaCampaign?.shotConfiguration?.sms.appChannelOptions?.toggleAppActivated) {
        channels.push('SMS')
      }
      if (this.mariaCampaign?.shotConfiguration?.push.appChannelOptions?.toggleAppActivated) {
        channels.push('push')
      }
      if (this.mariaCampaign?.shotConfiguration?.email.appChannelOptions?.toggleAppActivated) {
        channels.push('e-mail')
      }
      let statusMessage = ''
      if (['SCHEDULED', 'DRAFT'].includes(this.mariaCampaign.status)) {
        statusMessage = 'serão prejudicados ao ativar a campanha'
      } else {
        statusMessage = 'estão pausados atualmente.'
      }

      const channelsString = this.getChannelsMessage(channels)

      return `<span style="color: #004D99"> A quantidade de produtos ativos na campanha é menor do que as variáveis de produto utilizada nas mensagens. Por isso, os disparos ${
        channels.length > 1 ? 'nos canais' : 'no canal'
      } <b> ${channelsString} </b> ${statusMessage} </span>`
    },
    showInactiveProductsMessage() {
      let countActiveProductsOnOffer = 0
      switch (this.campaign.offerType) {
        case 'general':
          countActiveProductsOnOffer = this.countActiveProducts('offer_sales')
          break
        case 'percentage':
          countActiveProductsOnOffer = this.countActiveProducts('percentage_offer_sales')
          break
        case 'takepay':
          countActiveProductsOnOffer = this.countActiveProducts('takepay_offer_sales')
          break
        case 'combo':
          countActiveProductsOnOffer = this.countActiveProducts('combo_offer_sales')
          break
      }
      return countActiveProductsOnOffer < this.countVariables || !this.countVariables === 0
    },

    pageTitle() {
      return 'Nova campanha da mar.ia'
    },

    disableContinue() {
      return !this.campaign.offer_sales.length
    },

    errorInitialDate() {
      if (!this.$v.campaign.initial_date) return ''
      if (this.$v.campaign.initial_date.$error) {
        if (!this.$v.campaign.initial_date.required) return 'Selecione uma data inicial'
        else if (!this.$v.campaign.initial_date.isFuture) return 'A data de envio deve ser no futuro'
      } else return ''

      return ''
    },

    hasNoProducts() {
      let products = []
      switch (this.campaign.offerType) {
        case 'general':
          products = this.campaign.offer_sales
          break
        case 'percentage':
          products = this.campaign.percentage_offer_sales
          break
        case 'takepay':
          products = this.campaign.takepay_offer_sales
          break
        case 'combo':
          products = this.campaign.combo_offer_sales
          break
      }
      return !products || products.length === 0
    },

    offersTypeTabs() {
      let tab = []
      switch (this.campaign.offerType) {
        case 'general':
          tab = [
            {
              name: 'Desconto absoluto',
              itemsLength: getAllSingleProductsOutsideAndInsideGroup(this.campaign.offer_sales)?.length || 0,
              haveLength: true,
              offerSalesKeyName: this.offerSalesKeyNames.offer_sales,
            },
          ]
          break
        case 'percentage':
          tab = [
            {
              name: 'Desconto percentual',
              itemsLength: this.allPercentageOfferSalesProducts?.length || 0,
              haveLength: true,
              offerSalesKeyName: this.offerSalesKeyNames.percentage_offer_sales,
            },
          ]
          break
        case 'takepay':
          tab = [
            {
              name: 'Leve e pague',
              itemsLength: this.allTakeAndPayOfferSalesProducts?.length || 0,
              haveLength: true,
              offerSalesKeyName: this.offerSalesKeyNames.takepay_offer_sales,
              disabled: !this.allTakeAndPayOfferSalesProducts?.length,
            },
          ]
          break
        case 'combo':
          tab = [
            {
              name: 'Combo',
              itemsLength: this.allComboOfferSalesProducts?.length || 0,
              haveLength: true,
              offerSalesKeyName: this.offerSalesKeyNames.combo_offer_sales,
              disabled: !this.allComboOfferSalesProducts?.length,
            },
          ]
          break
      }
      return tab
    },
    allOfferSalesProducts() {
      return getAllSingleProductsOutsideAndInsideGroup(this.campaign?.offer_sales)
    },
    allPercentageOfferSalesProducts() {
      return getAllSingleProductsOutsideAndInsideGroup(this.campaign?.percentage_offer_sales)
    },
    allTakeAndPayOfferSalesProducts() {
      return getAllSingleProductsOutsideAndInsideGroup(this.campaign?.takepay_offer_sales)
    },
    allComboOfferSalesProducts() {
      return getAllSingleProductsOutsideAndInsideGroup(this.campaign?.combo_offer_sales)
    },

    primaryButton() {
      return {
        text: 'Continuar',
        action: this.tryingToSaveCampaign,
        isVisible: true,
        isDisabled: this.loadingSaveDraft,
        isLoading: this.loadingSaveActive,
      }
    },

    secondaryButton() {
      return this.isMariaCampaignFinished
        ? {}
        : {
            text: 'Salvar e sair',
            action: this.saveDraft,
            isVisible: !this.isCampaignActivated,
            isDisabled: false,
            isLoading: this.loadingSaveDraft,
          }
    },

    extraButton() {
      return {
        text: 'Voltar',
        action: this.goBack,
        isVisible: true,
        isDisabled: false,
      }
    },

    cancelButton() {
      return {
        text: this.isMariaCampaignFinished ? 'Fechar' : 'Cancelar',
        action: this.redirectCampaigns,
        isVisible: true,
        isDisabled: false,
      }
    },
  },

  async created() {
    window.scrollTo(0, 0)
    const eans = {
      offer_sales: [],
      percentage_offer_sales: [],
      takepay_offer_sales: [],
      trigger_product: [],
      target_products: [],
    }
    if (this.mariaCampaign.offerSelected) this.managementOffers = true
    if (!this.mariaCampaign.title) return this.goTomariaCampaignIndexTable()
    if (this.$route.params.from === 'Budget') {
      this.campaign = { ...this.mariaCampaign, eans }
    } else {
      const { offerType } = this.mariaCampaign
      this.campaign = { ...this.mariaCampaign, eans }
      if (this.mariaCampaign.offer_sales && offerType === 'general') {
        this.campaign = { ...this.campaign, offer_sales: this.getFormattedItems(this.mariaCampaign.offer_sales), offerType }
      }
      if (this.mariaCampaign.percentage_offer_sales && offerType === 'percentage') {
        this.campaign = { ...this.campaign, percentage_offer_sales: this.getFormattedItems(this.mariaCampaign.percentage_offer_sales), offerType }
      }
      if (this.mariaCampaign.takepay_offer_sales && offerType === 'takepay') {
        this.campaign = { ...this.campaign, takepay_offer_sales: this.getFormattedItems(this.mariaCampaign.takepay_offer_sales), offerType }
      }
      if (this.mariaCampaign.combo_offer_sales && offerType === 'combo') {
        this.campaign = { ...this.campaign, combo_offer_sales: this.getFormattedItems(this.mariaCampaign.combo_offer_sales), offerType }
      }
    }
    if (this.mariaCampaign?.units_configuration?.length) this.defaultDataType = this.mariaCampaign.units_configuration[0].dataType
  },

  methods: {
    getChannelsMessage(channels) {
      let channelsString = ''
      if (channels.length > 1) {
        channels.forEach((item, index) => {
          if (index === channels.length - 1) {
            channelsString += ` e ${item}`
          } else if (index === channels.length - 2) {
            channelsString += item
          } else {
            channelsString += `${item}, `
          }
        })
      } else channelsString = channels[0]
      return channelsString
    },
    countActiveProducts(offerTypeKey) {
      const currentCampaign = this.campaign[offerTypeKey]
      return currentCampaign.reduce((total, product) => {
        if (product.isGroup) {
          total += product.products.reduce((totalGroup, groupProduct) => {
            if (groupProduct.active) totalGroup++
            return totalGroup
          }, 0)
        } else {
          if (product.active) total++
        }
        return total
      }, 0)
    },
    goBack() {
      const isValid = this.validateInfos()
      if (!isValid) return
      this.forcePush = true
      this.SET_MARIA_CAMPAIGN(this.campaign)
      if (this.campaign._id) this.$router.push({ name: 'Edit Mar.ia campaign', params: { id: this.campaign._id, from: 'Product details' } })
      else this.$router.push({ name: 'New Mar.ia campaign' })
    },

    async saveDraft() {
      this.loadingSaveDraft = true
      const hasProducts = this.validateIfHasProducts()
      if (!hasProducts) return
      await this.upsertDraftMariaCampaign(
        {
          ...this.campaign,
          offer_sales: this.formatOfferSales(this.campaign.offer_sales),
          percentage_offer_sales: this.formatOfferSalesPercentage(this.campaign.percentage_offer_sales),
          takepay_offer_sales: this.formatOfferSalesTakeAndPay(this.campaign.takepay_offer_sales),
          combo_offer_sales: this.formatOfferSalesCombo(this.campaign.combo_offer_sales),
          ...this.getPartialPayload(),
        },
        this.isCampaignActivated
      )
      this.loadingSaveDraft = false
    },

    async saveCampaign() {
      const isValid = await this.validateInfos()
      const hasProducts = this.validateIfHasProducts()
      if (!isValid || !hasProducts) return
      this.SET_MARIA_CAMPAIGN(this.campaign)
      this.forcePush = true
      this.$router.push({ name: 'Budget' })
    },

    validateIfHasProducts() {
      let isValid = false
      if (this.hasNoProducts) {
        this.$snackbar({ message: 'Preencha todos os campos corretamente.', snackbarColor: 'error' })
      } else isValid = true
      return isValid
    },

    async validateInfos() {
      this.$v.$reset()
      this.$v.$touch()
      if (this.$v.$error) {
        this.$nextTick(() => {
          this.$vuetify.goTo(document.querySelector('.error--text'), { offset: 200 })
        })
        return false
      }

      let isValid = false
      switch (this.campaign.offerType) {
        case 'general':
          isValid = await this.$refs.productsAbsoluteDiscount.checkValidations()
          break
        case 'percentage':
          isValid = this.$refs.productsPercentageDiscount.checkValidations()
          break
        case 'takepay':
          isValid = this.$refs.productsTakeAndPayDiscount.checkValidations()
          break
        case 'combo':
          isValid = this.$refs.productsCombo.checkValidations()
          break
      }

      return isValid
    },

    updateEans(eansProduct, group) {
      const { offerType } = this.campaign
      let offer = 'offer_sales'
      if (offerType === 'percentage') offer = 'percentage_offer_sales'
      if (offerType === 'takepay') offer = 'takepay_offer_sales'
      if (offerType === 'combo') offer = 'combo_offer_sales'

      const indexGroup = findIndex(this.campaign[offer], group)
      const { eans, sku } = eansProduct

      if (group.isGroup) {
        const indexProduct = this.campaign[offer][indexGroup].products.findIndex((product) => product.sku === sku)
        this.campaign[offer][indexGroup].products[indexProduct].eans = eans
      } else {
        this.campaign[offer][indexGroup].eans = eans
      }
    },

    getEans(value) {
      this.campaign.eans = value
    },

    includesThisStatus(status) {
      return status.includes(this.campaign.status)
    },

    getFormattedItems(products) {
      const arrGroups = products.reduce((obj, item) => {
        if (item.isFormated) {
          if (!obj['products']) obj['products'] = []
          obj['products'].push(item)
          return obj
        }
        if (item.isGroup) {
          if (!obj[item.nameGroup]) obj[item.nameGroup] = []
          obj[item.nameGroup].push(item)
          return obj
        } else {
          item = {
            active: typeof item.active === 'boolean' ? item.active : true,
            ...item,
          }
          if (!obj['products']) obj['products'] = []
          obj['products'].push(item)
          return obj
        }
      }, {})

      const formattedItems = [
        ...Object.keys(arrGroups)
          .filter((key) => key !== 'products')
          .map((key) => {
            return {
              name: arrGroups[key][0].nameGroup,
              isGroup: arrGroups[key][0].isGroup,
              products: arrGroups[key],
              price_1: arrGroups[key][0].price_1,
              price_2: arrGroups[key][0].price_2,
              percentage_discount: arrGroups[key][0].percentage_discount ? arrGroups[key][0].percentage_discount : null,
              take: arrGroups[key][0].take ? arrGroups[key][0].take : null,
              pay: arrGroups[key][0].pay ? arrGroups[key][0].pay : null,
              ...arrGroups[key][0].groupInfo,
            }
          }),
      ]

      const newProducts = arrGroups['products'] ? [...arrGroups['products'], ...formattedItems] : formattedItems
      return newProducts.map((product) => ({ ...product, isFormated: true }))
    },
  },

  validations() {
    return {
      ...(this.isMariaCampaignActivated || this.isMariaCampaignFinished
        ? {
            campaign: {
              units: {},
              initial_date: {},
              final_date: {},
            },
          }
        : {
            campaign: {
              units: {
                required,
              },
              initial_date: {
                required,
                ...(!this.campaign.offerSelected ? { isFuture } : {}),
              },
              final_date: {
                required,
              },
            },
          }),
    }
  },
}
</script>

<style lang="scss" scoped>
$phone-size: 600px;
$tablet-size: 960px;

.mariaCampaign-details {
  &-text {
    & h2 {
      color: $cinza-d20;
      line-height: 120%;
      font-weight: bold;
      font-size: 26px;
    }

    & p {
      color: $cinza-l20;
      font-size: 14px;
      line-height: 150%;
      font-weight: normal;
    }
  }
}

@media screen and (max-width: 1100px) {
  .mariaCampaign-details {
    grid-template-columns: 1fr;
    gap: 10px;
  }
}

@media screen and (max-width: $phone-size) {
  .mariaCampaign-details-actions {
    display: block !important;
  }
}
</style>
